export type NicoMood = "happy" | "thinking" | "celebrate" | "encourage" | "sad";

const positions: Record<NicoMood, string> = {
  happy: "0% 0%",
  thinking: "0% 100%",
  celebrate: "50% 0%",
  encourage: "50% 100%",
  sad: "100% 100%"
};

export function Nico({ mood = "happy", message, compact = false }: { mood?: NicoMood; message?: string; compact?: boolean }) {
  return <div className={`nico nico-${mood} ${compact ? "nico-compact" : ""}`}>
    <span className="nico-character" style={{ backgroundPosition: positions[mood] }} role="img" aria-label={`Nico ${mood === "celebrate" ? "comemorando" : mood === "thinking" ? "pensando" : mood === "encourage" ? "incentivando" : mood === "sad" ? "triste" : "sorrindo"}`} />
    {message ? <div className="speech-bubble">{message}</div> : null}
  </div>;
}

